module.exports = __webpack_public_path__ + "static/media/cyuce018.66f1b8b2.jpg";